/**
 * NOS-7: Context for sections rendered inside a background image wrapper.
 * Sections use transparent background and light text when this is set.
 */
import { createContext, useContext, type ReactNode } from "react"

const SectionBackgroundContext = createContext(false)

export function SectionBackgroundProvider({
  value,
  children,
}: {
  value: boolean
  children: ReactNode
}) {
  return (
    <SectionBackgroundContext.Provider value={value}>
      {children}
    </SectionBackgroundContext.Provider>
  )
}

export function useSectionBackground() {
  return useContext(SectionBackgroundContext)
}
